import { render } from "./ChangePassword.vue?vue&type=template&id=05dc7c38"
import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=05dc7c38&scope=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/changePassword/ChangePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05dc7c38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05dc7c38', __exports__)) {
    console.log('reload')
    api.reload('05dc7c38', __exports__)
  }
  
  module.hot.accept("./ChangePassword.vue?vue&type=template&id=05dc7c38", () => {
    console.log('re-render')
    api.rerender('05dc7c38', render)
  })

}


export default __exports__